var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (_, _s, activeText, attr, counts, filterLabelMap, filterRoot, hideForSaleButton, includeAllWorksButton, infiniteScroll, params, pulldownVal, sd, total, undefined) {
buf.push("<div id=\"partner-filter\"><div id=\"partner-filter-nav\" class=\"filter-fixed-header-nav\"><div class=\"filter-fixed-header-left\"><em><span class=\"filter-artworks-num\"></span>&nbsp;Works</em></div><span id=\"partner-filter-artworks-nav\"><nav class=\"filter-nav filter-artworks-nav\">");
if ( ! _.isEmpty(counts.price_range) && ! hideForSaleButton)
{
buf.push("<a" + (jade.cls(['filter-button','filter-nav-only-for-sale',params.get('for_sale') == 'true' ? 'is-active' : ''], [null,null,true])) + "><div class=\"artsy-checkbox--checkbox\"><input type=\"checkbox\" id=\"only-for-sale\"" + (jade.attr("checked", ( params.get('for_sale') == 'true' ? 'checked' : undefined ), true, true)) + "><label for=\"only-for-sale\"></label></div><label for=\"only-for-sale\">Only for sale</label></a>");
}
if ( includeAllWorksButton)
{
buf.push("<a" + (jade.attr("href", filterRoot, true, true)) + " class=\"filter-button filter-nav-all\">All Works</a>");
}
if ( counts)
{
// iterate counts
;(function(){
  var $$obj = counts;
  if ('number' == typeof $$obj.length) {

    for (var name = 0, $$l = $$obj.length; name < $$l; name++) {
      var filter = $$obj[name];

if (!( name == 'total' || name == 'for_sale'))
{
buf.push("<div" + (jade.attr("id", "filter-dropdown-" + (name) + "", true, true)) + (jade.cls(['filter-dropdown',( params.has(name) && activeText ) ? 'is-active' : ''], [null,true])) + "><div class=\"filter-nav-main-text\">" + (jade.escape(null == (jade_interp = filterLabelMap[name].label) ? "" : jade_interp)) + "</div><div class=\"filter-nav-active-text\">" + (jade.escape(null == (jade_interp = activeText) ? "" : jade_interp)) + "</div><div class=\"icon-arrow-down\"></div><nav class=\"filter-dropdown-nav\"><a" + (jade.attr("data-attr", name, true, true)) + " data-val=\"\" href=\"\"><span class=\"filter-dropdown-text\">All " + (jade.escape((jade_interp = filterLabelMap[name].plural) == null ? '' : jade_interp)) + "</span><span class=\"filter-dropdown-count\"></span><span class=\"icon-check\"></span></a>");
// iterate filter
;(function(){
  var $$obj = filter;
  if ('number' == typeof $$obj.length) {

    for (var val = 0, $$l = $$obj.length; val < $$l; val++) {
      var key = $$obj[val];

if ( key && val)
{
var extraClasses = []
if(key.count == 0) extraClasses.push('is-disabled')
if(params.get(attr) == val) extraClasses.push('is-active')
buf.push("<a" + (jade.attr("data-attr", name, true, true)) + (jade.attr("data-val", val, true, true)) + (jade.attr("href", (
              filterRoot && filterRoot.match('booths') ?
              "" + (filterRoot) + "/" + (attr) + "/" + (val) + "" :
              "" + (filterRoot ? filterRoot : sd.CURRENT_PATH + '/artworks') + "?" + (name) + "=" + (val) + ""
            ), true, true)) + (jade.cls([extraClasses.join(' ')], [true])) + "><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = key.name) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\">(" + (jade.escape((jade_interp = _s.numberFormat(key.count)) == null ? '' : jade_interp)) + ")</span><span class=\"icon-check\"></span></a>");
}
    }

  } else {
    var $$l = 0;
    for (var val in $$obj) {
      $$l++;      var key = $$obj[val];

if ( key && val)
{
var extraClasses = []
if(key.count == 0) extraClasses.push('is-disabled')
if(params.get(attr) == val) extraClasses.push('is-active')
buf.push("<a" + (jade.attr("data-attr", name, true, true)) + (jade.attr("data-val", val, true, true)) + (jade.attr("href", (
              filterRoot && filterRoot.match('booths') ?
              "" + (filterRoot) + "/" + (attr) + "/" + (val) + "" :
              "" + (filterRoot ? filterRoot : sd.CURRENT_PATH + '/artworks') + "?" + (name) + "=" + (val) + ""
            ), true, true)) + (jade.cls([extraClasses.join(' ')], [true])) + "><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = key.name) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\">(" + (jade.escape((jade_interp = _s.numberFormat(key.count)) == null ? '' : jade_interp)) + ")</span><span class=\"icon-check\"></span></a>");
}
    }

  }
}).call(this);

buf.push("</nav></div>");
}
    }

  } else {
    var $$l = 0;
    for (var name in $$obj) {
      $$l++;      var filter = $$obj[name];

if (!( name == 'total' || name == 'for_sale'))
{
buf.push("<div" + (jade.attr("id", "filter-dropdown-" + (name) + "", true, true)) + (jade.cls(['filter-dropdown',( params.has(name) && activeText ) ? 'is-active' : ''], [null,true])) + "><div class=\"filter-nav-main-text\">" + (jade.escape(null == (jade_interp = filterLabelMap[name].label) ? "" : jade_interp)) + "</div><div class=\"filter-nav-active-text\">" + (jade.escape(null == (jade_interp = activeText) ? "" : jade_interp)) + "</div><div class=\"icon-arrow-down\"></div><nav class=\"filter-dropdown-nav\"><a" + (jade.attr("data-attr", name, true, true)) + " data-val=\"\" href=\"\"><span class=\"filter-dropdown-text\">All " + (jade.escape((jade_interp = filterLabelMap[name].plural) == null ? '' : jade_interp)) + "</span><span class=\"filter-dropdown-count\"></span><span class=\"icon-check\"></span></a>");
// iterate filter
;(function(){
  var $$obj = filter;
  if ('number' == typeof $$obj.length) {

    for (var val = 0, $$l = $$obj.length; val < $$l; val++) {
      var key = $$obj[val];

if ( key && val)
{
var extraClasses = []
if(key.count == 0) extraClasses.push('is-disabled')
if(params.get(attr) == val) extraClasses.push('is-active')
buf.push("<a" + (jade.attr("data-attr", name, true, true)) + (jade.attr("data-val", val, true, true)) + (jade.attr("href", (
              filterRoot && filterRoot.match('booths') ?
              "" + (filterRoot) + "/" + (attr) + "/" + (val) + "" :
              "" + (filterRoot ? filterRoot : sd.CURRENT_PATH + '/artworks') + "?" + (name) + "=" + (val) + ""
            ), true, true)) + (jade.cls([extraClasses.join(' ')], [true])) + "><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = key.name) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\">(" + (jade.escape((jade_interp = _s.numberFormat(key.count)) == null ? '' : jade_interp)) + ")</span><span class=\"icon-check\"></span></a>");
}
    }

  } else {
    var $$l = 0;
    for (var val in $$obj) {
      $$l++;      var key = $$obj[val];

if ( key && val)
{
var extraClasses = []
if(key.count == 0) extraClasses.push('is-disabled')
if(params.get(attr) == val) extraClasses.push('is-active')
buf.push("<a" + (jade.attr("data-attr", name, true, true)) + (jade.attr("data-val", val, true, true)) + (jade.attr("href", (
              filterRoot && filterRoot.match('booths') ?
              "" + (filterRoot) + "/" + (attr) + "/" + (val) + "" :
              "" + (filterRoot ? filterRoot : sd.CURRENT_PATH + '/artworks') + "?" + (name) + "=" + (val) + ""
            ), true, true)) + (jade.cls([extraClasses.join(' ')], [true])) + "><span class=\"filter-dropdown-text\">" + (jade.escape(null == (jade_interp = key.name) ? "" : jade_interp)) + "</span><span class=\"filter-dropdown-count\">(" + (jade.escape((jade_interp = _s.numberFormat(key.count)) == null ? '' : jade_interp)) + ")</span><span class=\"icon-check\"></span></a>");
}
    }

  }
}).call(this);

buf.push("</nav></div>");
}
    }

  }
}).call(this);

}
buf.push("</nav></span></div><div id=\"partner-artworks\">");
jade_mixins["bordered-pulldown"] = jade_interp = function(defaultVal, label, isDisabled){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ( label)
{
buf.push("<span" + (jade.cls(['bordered-pulldown-label',"" + (isDisabled ? 'is-disabled' : '') + ""], [null,true])) + ">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</span>");
}
buf.push("<div" + (jade.cls(['bordered-pulldown',"" + (isDisabled ? 'is-disabled' : '') + ""], [null,true])) + "><a href=\"#\" class=\"bordered-pulldown-toggle\"><span class=\"bordered-pulldown-text\">" + (jade.escape(null == (jade_interp = defaultVal) ? "" : jade_interp)) + "</span><div class=\"bordered-pulldown-toggle-caret\"><span class=\"caret\"></span></div></a><div class=\"bordered-pulldown-options\">");
block && block();
buf.push("</div></div>");
};










buf.push("<div" + (jade.cls(['filter-artworks',infiniteScroll ? '' : 'filter-artworks-no-infinite-scroll'], [null,true])) + "><div class=\"filter-artworks-sort-count\"><div class=\"filter-sort-count\"><h2 class=\"filter-heading large-garamond-header\"></h2><h4 class=\"filter-sort-count-count\">Showing&nbsp;<span class=\"filter-sort-count-total\">" + (jade.escape(null == (jade_interp = typeof total == 'number' ? total : '0 works') ? "" : jade_interp)) + "</span></h4><div class=\"filter-sort-count-pulldown\">");
jade_mixins["bordered-pulldown"].call({
block: function(){
buf.push("<a data-sort=\"-partner_updated_at\" href=\"#\">Recently Updated</a><a data-sort=\"-year\" href=\"#\">Artwork Year (desc.)</a><a data-sort=\"year\" href=\"#\">Artwork Year (asc.)</a>");
}
}, (pulldownVal || 'Recently Updated'), 'Sort by:');
buf.push("</div></div></div><div class=\"filter-artworks-list\"></div><div class=\"filter-artworks-spinner\"><div class=\"loading-spinner\"></div></div></div></div></div>");}.call(this,"_" in locals_for_with?locals_for_with._:typeof _!=="undefined"?_:undefined,"_s" in locals_for_with?locals_for_with._s:typeof _s!=="undefined"?_s:undefined,"activeText" in locals_for_with?locals_for_with.activeText:typeof activeText!=="undefined"?activeText:undefined,"attr" in locals_for_with?locals_for_with.attr:typeof attr!=="undefined"?attr:undefined,"counts" in locals_for_with?locals_for_with.counts:typeof counts!=="undefined"?counts:undefined,"filterLabelMap" in locals_for_with?locals_for_with.filterLabelMap:typeof filterLabelMap!=="undefined"?filterLabelMap:undefined,"filterRoot" in locals_for_with?locals_for_with.filterRoot:typeof filterRoot!=="undefined"?filterRoot:undefined,"hideForSaleButton" in locals_for_with?locals_for_with.hideForSaleButton:typeof hideForSaleButton!=="undefined"?hideForSaleButton:undefined,"includeAllWorksButton" in locals_for_with?locals_for_with.includeAllWorksButton:typeof includeAllWorksButton!=="undefined"?includeAllWorksButton:undefined,"infiniteScroll" in locals_for_with?locals_for_with.infiniteScroll:typeof infiniteScroll!=="undefined"?infiniteScroll:undefined,"params" in locals_for_with?locals_for_with.params:typeof params!=="undefined"?params:undefined,"pulldownVal" in locals_for_with?locals_for_with.pulldownVal:typeof pulldownVal!=="undefined"?pulldownVal:undefined,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined,"total" in locals_for_with?locals_for_with.total:typeof total!=="undefined"?total:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;